import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserCard from "./UserCard";
import LatestResult from "./LatestResult";
import Productivity from "./Productivity";
import GameEngagement from "./GameEngagement";
import Completed from "./Completed";
import ActiveCourses from "./ActiveCourses";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import DateRangeSelector from "../filterDataRange/DateRangeSelector";
import { FaArrowLeftLong } from "react-icons/fa6";
import { exportMultipleChartsToPdf, generateExcel } from "../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../SvgIconsData";
import Skeleton from 'react-loading-skeleton';
import OnLoadSection from "./OnLoadSection";

const { innerWidth: width, innerHeight: height } = window;

const UserDashboard = ({userPlan}) => {
  const location = useLocation();
  var navigate = useNavigate();
  const params = useParams();
  const { uuid } = params;
  const userData = useSelector((state) => state.userSlice);
  if (!location.state || !location.state.uuid) {
    navigate(`/dashboard/${userData.user.uuid}`, { state: userData.user });
  }
  const configData = useSelector((state) => state.configSlice);
  const [labels, setWeekdays] = useState([]);
  const [guidedCounts, setGuidedCounts] = useState([]);
  const [unguidedCounts, setUnguidedCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [isHome, setIsHome] = useState(true);
  const [showTour, setShowTour] = useState(true)
  const [showEndVideo, setShowEndVideo] = useState(false)
  const [showWalkThroughVideo, setShowWalkThroughVideo ] = useState(false);

  useEffect(() => {
    setShowWalkThroughVideo(!!configData?.config?.walkThroughVideo)
  }, [configData]);

  useEffect(()=>{
    localStorage.getItem("tour") && setShowTour(false);
    },[])

  //   useEffect(() => {
  //     const messageListener = (event) => {
  //       if (event.data === 'endPlayer'){
  //         setShowEndVideo(true)
  //       }
  //     };
  //     window.addEventListener('message', messageListener);
  //     return () => {
  //       window.removeEventListener('message', messageListener);
  //     };
  //   }, []); 


  useEffect(() => {
    if (window.location.pathname.startsWith("/team/user/")) {
      setIsHome(false);
    }
  }, []);

  const [analytics, setUserAnalytics] = useState({
    weekCounts: {
      all: 0,
      guided: 0,
      unguided: 0,
    },
    modules: [],
    totalCounts: {
      all: 0,
      guided: 0,
      unguided: 0,
    },
  });

  const getUserAnalytics = async () => {
    try {
      const userAnalytics = await axios.get(
        `${configData.config.API_URL}/api/dashboard/user/${configData.config.MODE}/${uuid}`,        {
          params:{
            filter: filter,
            applicationId: configData.config.applicationId
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setUserAnalytics(userAnalytics.data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  function extractData(analytics) {
    const labels = [];
    const guidedCounts = [];
    const unguidedCounts = [];

    analytics?.forEach((day) => {
      labels.push(day.label);
      guidedCounts.push(day.counts.guided);
      unguidedCounts.push(day.counts.unguided);
    });

    return { labels, guidedCounts, unguidedCounts };
  }

  useEffect(() => {
    getUserAnalytics();
  }, [filter]);

  useEffect(() => {
    const { labels, guidedCounts, unguidedCounts } = extractData(analytics?.durationCounts);
    setUnguidedCounts(unguidedCounts);
    setGuidedCounts(guidedCounts);
    setWeekdays(labels);
  }, [analytics]);

  const { modules } = analytics;
  const tostart = modules;

  const ongoing = modules.sort((a, b) => {
    if (b.progress === 100) return -1;
    return b.progress - a.progress;
  });

  const completed = modules.sort((a, b) => {
    return b.progress - a.progress;
  });

  const tableData1 = [
    ["User DashBoard", ""],
    ["Name", userData.user.name],
    ["Team Name", userData.user.group.name],
    ["Date Range", `${moment(analytics?.start).format('D/M/YYYY')}-${moment(analytics?.end).format('D/M/YYYY')}`],
    ["Report Generated at", moment().format("lll")],
    ["Time Spent - Total", analytics?.duration?.all?.sum?.humanReadable],
    ["Time Spent - Guided", analytics?.duration?.guided?.sum?.humanReadable],
    ["Time Spent - Unguided", analytics?.duration?.unguided?.sum?.humanReadable],
  ];

  let arr = [];

  modules.map((item, index) => {
    let isCertificate = "Pending";
    if (item.certificate !== null) {
      isCertificate = "Achieved";
    }
    arr.push([item.name, item.progress, isCertificate]);
  });

  const tableData2 = [["Courses", "Progress", "Certificate"], ...arr];

  // if (loading) return <MyDashboardLoad />;
  return (
    <>
      <div className="container-fluid bg-grey-main dashboard p-3 pt-2">
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            {!isHome && <button
                className="backbtn cursor-pointer ps-2 mt-2"
                title="Back"
                onClick={() => navigate(-1)}>
                {" "}
                <FaArrowLeftLong /> Back{" "}
              </button>
            }
          </div>

          <div className="col-md-6 d-flex align-itmes-center gap-2 atdash">
            <DateRangeSelector selected={filter} setSelected={setFilter} />
            { userPlan === 'basic' && 
            <>
            <button
              className="DefaultRedBtn download px-2"
              title="Download PDF"
              onClick={() => exportMultipleChartsToPdf("User_Dashboard", tableData1, tableData2)}>
              <PDFDownloadIcon />
            </button>
            <button
              className="DefaultRedBtn download px-2"
              title="Download Excel"
              onClick={() => generateExcel("User_Dashboard", tableData1, tableData2)}>
              <EXLDownloadIcon />
            </button>
            </> 
          }
          </div>
        </div>

        <UserCard analytics={analytics} user={location.state} isHome={isHome} loading={loading} />
        
        <div className="row mt-0">
          <div className=" col-lg-12 col-xl-9 col-xxl-9" >
            <div className="row mt-3">
              <div className="col-md-6">
                <LatestResult modules={ongoing}  loading={loading} />
              </div>
              <div className="col-md-6">
                <div className="cardbox overflow-hidden custom-chart">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{loading ? ( <Skeleton width="5vw" /> ) : <> Productivity </> }</h5>
                    <p className="mb-1">{loading ? ( <Skeleton width="5vw" /> ) :  <>Total Sessions : {analytics.totalCounts.all} </> }</p>
                  </div>
                  <div className="chartlegends">
                    <p className="mb-1">{loading ? ( <Skeleton width="5vw" /> ) :  <> Trainings : {analytics.totalCounts.guided} </> }</p>
                    <p className="mb-1">{loading ? ( <Skeleton width="5vw" /> ) :  <> Assessments : {analytics.totalCounts.unguided} </> }</p>
                  </div>
                  <Productivity
                    page="myDashboard"
                    labels={labels}
                    guidedCounts={guidedCounts}
                    unguidedCounts={unguidedCounts}
                    seriesName1="Training"
                    seriesName2="Assessment"
                    loading={loading}
                  />
                </div>
              </div>
            </div>
            <ActiveCourses modules={tostart.slice(0, 3)} loading={loading} />
          </div>
          <div className=" col-lg-12 col-xl-3 col-xxl-3">
            <div className="cardbox position-relative mt-3">
              <GameEngagement modules={analytics.modules} loading={loading}/>
              <Completed modules={completed} loading={loading}/>
            </div>
          </div>
        </div>

        {(showWalkThroughVideo && width > 776 && showTour) && <OnLoadSection setShowTour={setShowTour} showEndVideo={showEndVideo} /> }

      </div>
    </>
  );
};

export default UserDashboard;
